import axios from '@/plugins/axios'

const actions = {
  GET_LOGIN_STAGE() {
    // 判断session是否过期
    return axios.get('/api/session/session')
  },
  /**
   * 域登录
   */
  domainLogin({ state, commit }) {
    let IFRAME = document.getElementById('AD-LOGIN')
    let createIframe = (url) => {
      let iframe = document.createElement('iframe')
      iframe.id = 'AD-LOGIN'
      iframe.style.position = 'fixed'
      iframe.style.fixed = 99
      iframe.src = url
      commit('CHANGE_LOADING', true)
      // commit('SET_LOGIN_INFO', '')
      document.body.appendChild(iframe)
    }
    if (!IFRAME) {
      createIframe(state.domainLoginUrl)
    } else {
      // 先删除在创建
      document.body.removeChild(IFRAME)
      createIframe(state.domainLoginUrl)
    }
  }
}

export default actions
